import { useState, useEffect } from 'react';
import api from '../../services/api';
import { Load } from '../../components/Load';
import { Header } from '../../components/Header';
import { Select, Options } from '../../components/Select';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { CardContent } from '../../components/CardContent';
import { Col, Row, Pagination, Button, Form } from 'react-bootstrap';
import { Table, TBody, TCell, TGroup, THeader, TRow, ThCell } from '../../components/Table/Table';
import { Title } from '../../components/Title';
import './style.css';
// import { Bar, Doughnut } from 'react-chartjs-2';
// import { ChartCard } from '../../components/Charts';
import ChartsSection from '../../components/ChartsCredenciado';
import { useNavigate } from 'react-router-dom';

export function ResumoVendasCredenciados() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [employees, setEmployees] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [employeesPerPage, setEmployeesPerPage] = useState(20);
    const [employeesPerPageOptions] = useState([5, 10, 15, 20, 50, 100]);

    const [searchQuery, setSearchQuery] = useState('');
    const [currentFilteredEmployees, setCurrentFilteredEmployees] = useState([]);

    // Calcula o índice do primeiro e do último funcionário na página atual
    const indexOfLastEmployee = currentPage * employeesPerPage;
    const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;

    const currentEmployees = employees.slice(indexOfFirstEmployee, indexOfLastEmployee);

    // const filteredEmployees = employees.filter((employee: any) => {

    //     const cpfClean = employee.empresa.replace(/[\.-]/g, ''); // Remove '.' e '-'

    //     return (
    //         employee.empresa.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //         cpfClean.includes(searchQuery) ||
    //         employee.id.toString().includes(searchQuery)
    //     );
    // });

    const [show, setShow] = useState(false);
    const [idSelected, setIdSelected] = useState('');

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    const handleClose = () => setShow(false);

    const showModal = (id: any) => {
        setIdSelected(id)
        setShow(true)
    }
    const handleConfirm = async () => {
        try {
            await api.delete(`empresas/deletar/${idSelected}`);
            const response = await api.get('empresas')
            setEmployees(response.data);
            setAlert({ show: true, message: 'Item excluído com sucesso!', variant: 'success' });
        } catch (error) {
            console.error("Erro ao tentar excluir:", error);
            setAlert({ show: true, message: 'Erro ao excluir item', variant: 'danger' });
        }
        handleClose();
    };

    // useEffect(() => {
    //     const indexOfLastFilteredEmployee = currentPage * employeesPerPage;
    //     const indexOfFirstFilteredEmployee = indexOfLastFilteredEmployee - employeesPerPage;
    //     // const newCurrentFilteredEmployees = filteredEmployees.slice(indexOfFirstFilteredEmployee, indexOfLastFilteredEmployee);

    //     setCurrentFilteredEmployees(newCurrentFilteredEmployees);
    // }, [currentPage, employeesPerPage]);

    // Function to load companies
    const loadCompanies = async () => {
        try {
            const response = await api.get('empresas');
            setCompanies(response.data.message ? [] : response.data);
            setSelectedCompany(response.data.length > 0 ? response.data[0].id : null);
        } catch (error) {
            console.error("Error fetching companies:", error);
        } finally {
            setIsLoading(false);
        }
    };
    const loadEmployees = async (companyId: any) => {
        try {
            const response = await api.get('listar-resumo-credenciado')

            const resumoCredenciado = response.data.data.map((resumo: any) => {
                const totalPagamento = resumo.pgrPedidos.pgrPagamentos.total;
                const porcentagemCredenciado = resumo.pgrCredenciado.porcentagem_comissao;

                const valorCredenciado = totalPagamento * (porcentagemCredenciado / 100);

                return {
                    ...resumo,
                    valorCredenciado
                };
            });

            setEmployees(resumoCredenciado);
        } catch (error) {
            console.error("Error fetching employees:", error);
        }
    };

    const handleEmployeesPerPageChange = (value: any) => {
        setEmployeesPerPage(Number(value));
        setCurrentPage(1); // Volta para a primeira página ao mudar a quantidade por página
    };
    // Load companies initially
    useEffect(() => {
        loadCompanies();
    }, []);

    useEffect(() => {
        loadEmployees(selectedCompany);
    }, [selectedCompany]); // Carregar funcionários quando a empresa selecionada for alterada

    const handleSelectCompany = (id: any) => {
        setSelectedCompany(id);
    };

    const handleStatusChange = async (employeeId: any, currentStatus: any) => {
        const newStatus = currentStatus === true ? false : true;

        try {
            await api.post('status-funcionarios', { id_empresa: selectedCompany, id_funcionario: employeeId, status: newStatus });
            // Reload employees to reflect the change
            loadEmployees(selectedCompany);
        } catch (error) {
            console.error("Error updating employee status:", error);
        }
    };

    // Atualizar a consulta de pesquisa
    const handleSearchChange = (value: string) => {
        setSearchQuery(value);
        setCurrentPage(1);
    };

    /*paginação*/
    const paginationItems = () => {
        let items = [];
        const totalPaginas = Math.ceil(employees.length / employeesPerPage); // Use filteredEmployees para calcular o total de páginas

        // Primeira página
        if (currentPage > 2) {
            items.push(
                <Pagination.Item
                    key="first"
                    onClick={() => setCurrentPage(1)}
                >
                    1
                </Pagination.Item>
            );
        }

        // Reticências antes da página atual, se necessário
        if (currentPage > 3) {
            items.push(<Pagination.Ellipsis key="startEllipsis" disabled />);
        }

        // Página anterior à atual, se aplicável
        if (currentPage > 1) {
            items.push(
                <Pagination.Item
                    key={currentPage - 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                >
                    {currentPage - 1}
                </Pagination.Item>
            );
        }

        // Página atual
        items.push(
            <Pagination.Item
                key={currentPage}
                active
            >
                {currentPage}
            </Pagination.Item>
        );

        // Página seguinte à atual, se aplicável
        if (currentPage < totalPaginas) {
            items.push(
                <Pagination.Item
                    key={currentPage + 1}
                    onClick={() => setCurrentPage(currentPage + 1)}
                >
                    {currentPage + 1}
                </Pagination.Item>
            );
        }

        // Reticências depois da página atual, se necessário
        if (currentPage < totalPaginas - 2) {
            items.push(<Pagination.Ellipsis key="endEllipsis" disabled />);
        }

        // Última página
        if (currentPage < totalPaginas - 1) {
            items.push(
                <Pagination.Item
                    key="last"
                    onClick={() => setCurrentPage(totalPaginas)}
                >
                    {totalPaginas}
                </Pagination.Item>
            );
        }

        return items;
    };

    const getPaymentTypeDescription = (tipo: string) => {
        switch (tipo) {
            case 'account_money':
                return 'Dinheiro na Conta';
            case 'credit_card':
                return 'Cartão de Crédito';
            case 'debit_card':
                return 'Cartão de Débito';
            case 'bank_transfer':
                return 'Transferência Bancária';
            case 'ticket':
                return 'Boleto';
            case 'P':
                return 'PIX';
        }
    };

    const getStatusDetails = (status: string) => {
        switch (status) {
            case 'P':
                return { color: 'orange', text: 'Pendente' };
            case 'R':
                return { color: 'blue', text: 'Em Revisão' };
            case 'RE':
                return { color: 'purple', text: 'Reembolsado' };
            case 'CB':
                return { color: 'red', text: 'Chargeback' };
            case 'C':
                return { color: 'grey', text: 'Cancelado' };
            case 'A':
                return { color: 'green', text: 'Aprovado' };
            default:
                return { color: 'black', text: 'Desconhecido' };
        }
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='./' />
            <Main>
                <CardContent>
                    <ChartsSection />
                    <Col className='d-flex justify-content-center'>
                        <Button variant='primary' onClick={() => navigate('/comissoes-credenciado')}>
                            Visualizar Resumo das Comissões
                        </Button>
                    </Col>
                </CardContent>
                <CardContent>
                    <Row className='my-4'>
                        <Title text="Vendas" />
                    </Row>
                    <Row className='mb-4'>
                        <Col sm={10} className='my-2 d-flex align-items-end'>
                            <span>Página {currentPage} de {Math.ceil(employees.length / employeesPerPage)}</span>

                        </Col>
                        <Col sm={2} className='my-2 d-flex justify-content-end'>
                            <Select id='employeesPerPageSelect' onSelect={handleEmployeesPerPageChange}>
                                {employeesPerPageOptions.map((option) => (
                                    <Options
                                        key={option}
                                        value={option}
                                        name={`${option} por página`}
                                        selected={option === employeesPerPage}
                                    />
                                ))}
                            </Select>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <div style={{ border: '1px solid #007bff', borderRadius: '6px', overflow: 'hidden', marginTop: '30px' }}>
                                <div style={{ overflow: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: '#007bff', color: 'white', textAlign: 'center' }}>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Cód</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Empresa</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Comissão à receber</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Forma de Pagamento</th>
                                                <th style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid white', fontSize: '13px', fontWeight: 'normal' }}>Status</th>
                                                <th style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>Comprovante</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {employees.length > 0 ? (
                                                employees.map((employee: any) => (
                                                    <tr key={employee.id}>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.id}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{employee.pgrEmpresa.nome}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>R$ {employee.valorCredenciado.toFixed(2)}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal' }}>{getPaymentTypeDescription(employee.pgrPedidos.pgrPagamentos.tipo)}</td>
                                                        <td style={{ padding: '15px', textAlign: 'center', borderRight: '1px solid lightgray', fontSize: '13px', fontWeight: 'normal', color: getStatusDetails(employee.pgrPedidos.pgrPagamentos.status).color }}>
                                                            {getStatusDetails(employee.pgrPedidos.pgrPagamentos.status).text}
                                                        </td>
                                                        <td style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                            {employee.comprovante_pagamento_credenciado ? (
                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                                    <a href={`data:application/pdf;base64,${encodeURIComponent(employee.comprovante_pagamento_credenciado)}`} download="comprovante_pagamento.pdf">
                                                                        Baixar Comprovante
                                                                    </a>
                                                                </div>
                                                            ) : (
                                                                'Sem Comprovante'
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={6} style={{ padding: '15px', textAlign: 'center', fontSize: '13px', fontWeight: 'normal' }}>
                                                        Não há dados para serem mostrados
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col className='d-flex justify-content-center mt-4'>
                            <div className="pagination">
                                <Pagination>
                                    {paginationItems()}
                                </Pagination>
                            </div>
                        </Col>
                    </Row>
                </CardContent>
            </Main>
        </div >
    );
}